import { render, staticRenderFns } from "./TCLAGaps.vue?vue&type=template&id=7bc5b0f0&scoped=true"
import script from "./TCLAGaps.vue?vue&type=script&lang=js"
export * from "./TCLAGaps.vue?vue&type=script&lang=js"
import style0 from "./TCLAGaps.vue?vue&type=style&index=0&id=7bc5b0f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc5b0f0",
  null
  
)

export default component.exports